import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { ReplaceableComponentsService } from '@abp/ng.core';
import { eThemeLeptonXComponents } from '@volosoft/abp.ng.theme.lepton-x';
import { SguRoutesComponent } from './sgu-routes.component';

export function initSguRoutesComponent(): void {
  const replaceableComponents = inject(ReplaceableComponentsService);

  replaceableComponents.add({
    key: eThemeLeptonXComponents.Routes,
    component: SguRoutesComponent,
  });
}

export function provideSguRoutesComponent(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      initSguRoutesComponent();
    }),
  ]);
}
